
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { CheckCircle2, Zap } from 'lucide-react';
import confetti from 'canvas-confetti';

const SuccessPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Launch confetti
        const duration = 5 * 1000;
        const animationEnd = Date.now() + duration;
        const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

        const randomInRange = (min, max) => Math.random() * (max - min) + min;

        const interval = setInterval(function () {
            const timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
                return clearInterval(interval);
            }

            const particleCount = 50 * (timeLeft / duration);
            confetti({
                ...defaults,
                particleCount,
                origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
            });
            confetti({
                ...defaults,
                particleCount,
                origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
            });
        }, 250);

        // Redirect after 5 seconds
        const timer = setTimeout(() => {
            navigate('/app');
        }, 5000);

        return () => {
            clearInterval(interval);
            clearTimeout(timer);
        }
    }, [navigate]);

    return (
        <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4 text-center">
            <div className="w-24 h-24 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mb-8 animate-in zoom-in duration-500">
                <CheckCircle2 className="w-12 h-12 text-green-600 dark:text-green-400" />
            </div>

            <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent animate-in slide-in-from-bottom-4 duration-700">
                Pagamento Confirmado!
            </h1>

            <p className="text-xl text-muted-foreground max-w-lg mb-8 animate-in slide-in-from-bottom-8 duration-700 delay-100">
                Bem-vindo ao <span className="font-semibold text-foreground">SkipLater Premium</span>. <br />
                Sua jornada para uma vida melhor começa agora.
            </p>

            <div className="flex flex-col gap-4 w-full max-w-sm animate-in slide-in-from-bottom-8 duration-700 delay-200">
                <Button
                    size="lg"
                    className="w-full bg-green-600 hover:bg-green-700 text-white h-12 text-lg shadow-lg hover:shadow-xl transition-all"
                    onClick={() => navigate('/app')}
                >
                    <Zap className="w-5 h-5 mr-2" />
                    Acessar Plataforma Agora
                </Button>
                <p className="text-sm text-muted-foreground animate-pulse">
                    Redirecionando em alguns segundos...
                </p>
            </div>
        </div>
    );
};

export default SuccessPage;
